import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { getFocusStyles, getVariantStyles } from '../Button/styles';
import { baseStyles, shapeStyles, sizeStyles } from './styles';
function IconButtonComponent(props, ref) {
    const { component, children, variant = 'primary', size = 'medium', color = 'blue', shape = 'square', label, isSelected = false, disabled = false, type, ...componentProps } = props;
    const Component = component || 'button';
    const buttonProps = {};
    if (Component === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    return (_jsx(Component, { ref: ref, "aria-label": label, css: [
            baseStyles,
            getFocusStyles(color, variant),
            sizeStyles[size],
            shapeStyles[shape],
            getVariantStyles(variant, color, isSelected),
        ], "data-disabled": disabled || undefined, tabIndex: disabled ? -1 : 0, ...buttonProps, ...componentProps, children: children }));
}
/**
 * A component that renders an icon within a button
 */
export const IconButton = React.forwardRef(IconButtonComponent);
